import React from "react";

export default function Bassmalah(){
    return (
        <p className="text-2xl md:text-5xl verse leading-loose text-center my-4">
            بِـــــــــــسْمِ ٱللَّهِ ٱلرَّحْمَـــــــــٰنِ ٱلرَّحِيـــــمِ 
        </p>
    )
}